module.exports = {"TXTCLI_Contact_Support":{"id":"TXTCLI_Contact_Support","defaultMessage":"サポートへのお問い合わせ","track":"Contact Support"}}